import React from 'react';
import {
  Title,
  SubTitle,
  FlowName,
  Footer,
  Container,
  DivIcon,
} from './styles';
import Close from '../../../../assets/icons/Close';
import Button from '../../../../components/general/Button';
import Modal from '../../../../components/general/Modal';
import { useDispatch, useSelector } from 'react-redux';
import {
  handleSetDefault,
  handleRemoveModel,

} from '../../../../state/flows/actions';

import { usePromiseTracker, trackPromise } from 'react-promise-tracker';
import ReactLoading from 'react-loading';


import { toastAlert } from '../../../../components/Toastify/index';
import { ActionCreators } from 'redux-undo';
import { useHistory } from "react-router-dom";
import { updateFlow } from '../../../../state/undoFlow/actions';
const DeleteVersion = ({
  current,
  loadflow,
  isOpen,
  onClose,
  selector = '#root',
  className = 'nodrag',
}) => {
  const dispatch = useDispatch();

  const { promiseInProgress } = usePromiseTracker({ area: 'delete-flow' });

  const flow = useSelector((state) => state.flows.pane.flow);
  const main = flow.main;
  const versions = flow.versions;
  const history = useHistory();




  const loadBaseModel = (flowId) => {
    const baseVersion = versions.find(item => item._id === flowId)
    const elements = baseVersion.elements;
    dispatch(updateFlow(elements));
    dispatch(ActionCreators.clearHistory());
    history.push({
      pathname: "/flowpane/edition",
      state: "edition",
      search:
        "?" +
        new URLSearchParams({
          flowId,
        }).toString(),
    });

  }


  const handleDelete = () => {

    try {
      const flowId = current._id;


      if (flowId === main.default) {

        //Versão padrão
        //Caso o modelo deletado seja a versão padrão 
        trackPromise(
          dispatch(
            handleSetDefault({
              flowId: main._id,
              versionId: null,
            })
          )
            .then(() => dispatch(handleRemoveModel(flowId)))
            .then((res) => {
              const title = res?.payload.flow.title;
              toastAlert({ msg: `Versão '${title}'  DELETADA com sucesso!` });
              loadflow(main);
              onClose();
            })
          , 'delete-flow')

      } else {
        //Versão não padrão

        trackPromise(
          dispatch(handleRemoveModel(flowId)).then((res) => {

            const title = res?.payload.flow.title;
            const baseModel = res?.payload.flow.baseModel;
            const type = res?.payload.flow.type
            toastAlert({ msg: `Versão '${title}' DELETADA com sucesso!` });
            if (baseModel) {
              //Caso o modelo contenha outras versões
              loadBaseModel(baseModel.flowId)
            } else if (type === 'main') {
              //Caso o modelo seja do tipo main e não tenha outras versões
              history.push('/modelflows')
            } else {
              //Caso o modelo seja do tipo version, carrega na tela o modelo main
              loadflow(main);
            }
            onClose();
          })
          , 'delete-flow')
      }

    } catch (err) {
      toastAlert({ msg: `Houve algum ERRO ao deletar o modelo selecionado`, isError: true });
      console.error(err.message);
      onClose();
    }

  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      selector={selector}
      className={className}
    >
      <Container>
        <Title>Excluir fluxo</Title>
        <SubTitle style={{ color: 'red' }}>
          {`Deseja seguir com a exclusão do modelo?`}
        </SubTitle>
        {!promiseInProgress ? (
          <>
            <FlowName>{current.title}</FlowName>
            <Footer>
              <Button
                outline
                content="Cancelar"
                width={'11.3125rem'}
                height={'2.625rem'}
                onClick={onClose}
              />
              <Button
                content="Sim, excluir"
                width={'11.3125rem'}
                height={'2.625rem'}
                onClick={handleDelete}
              />
            </Footer>

          </>
        ) : (
          <div
            style={{
              margin: '0 auto',
              padding: '2rem',

            }}
          >
            <ReactLoading type="bars" color="#118052" />
          </div>

        )}


        <DivIcon>
          <Close onClick={onClose} />
        </DivIcon>
      </Container>
    </Modal >
  );
};

export default DeleteVersion;
